import { useTranslation } from "react-i18next";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface LiteralEInfoModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function LiteralEInfoModal({
  open,
  onOpenChange,
}: LiteralEInfoModalProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle className="text-foreground">
            {t("onboarding.literalEInfoModal.title")}
          </DialogTitle>
        </DialogHeader>
        <div className="max-h-[70vh] space-y-4 overflow-y-auto pr-1 text-sm">
          <p className="text-muted-foreground">
            {t("onboarding.literalEInfoModal.intro")}
          </p>
          <p className="font-medium text-foreground">
            {t("onboarding.literalEInfoModal.underThisRegime")}
          </p>
          <ul className="list-inside list-disc space-y-1 text-muted-foreground">
            <li>{t("onboarding.literalEInfoModal.bullet1")}</li>
            <li>{t("onboarding.literalEInfoModal.bullet2")}</li>
            <li>{t("onboarding.literalEInfoModal.bullet3")}</li>
          </ul>

          <p className="font-semibold text-foreground">
            {t("onboarding.literalEInfoModal.benefitsTitle")}
          </p>

          <div className="space-y-2">
            <p className="font-medium text-foreground">
              {t("onboarding.literalEInfoModal.benefit1Title")}
            </p>
            <p className="text-muted-foreground">
              {t("onboarding.literalEInfoModal.benefit1Body")}
            </p>
            <p className="text-muted-foreground">
              {t("onboarding.literalEInfoModal.benefit1Points")}
            </p>
          </div>

          <div className="space-y-2">
            <p className="font-medium text-foreground">
              {t("onboarding.literalEInfoModal.benefit2Title")}
            </p>
            <p className="text-muted-foreground">
              {t("onboarding.literalEInfoModal.benefit2Body")}
            </p>
          </div>

          <div className="space-y-2">
            <p className="font-medium text-foreground">
              {t("onboarding.literalEInfoModal.benefit3Title")}
            </p>
            <p className="text-muted-foreground">
              {t("onboarding.literalEInfoModal.benefit3Body")}
            </p>
          </div>

          <div className="space-y-2">
            <p className="font-medium text-foreground">
              {t("onboarding.literalEInfoModal.benefit4Title")}
            </p>
            <p className="text-muted-foreground">
              {t("onboarding.literalEInfoModal.benefit4Body")}
            </p>
          </div>

          <p className="text-muted-foreground">
            {t("onboarding.literalEInfoModal.whyPlatformsShow")}
          </p>

          <p className="font-semibold text-foreground">
            {t("onboarding.literalEInfoModal.summaryTitle")}
          </p>
          <ul className="list-inside list-disc space-y-1 text-muted-foreground">
            <li>{t("onboarding.literalEInfoModal.summary1")}</li>
            <li>{t("onboarding.literalEInfoModal.summary2")}</li>
            <li>{t("onboarding.literalEInfoModal.summary3")}</li>
            <li>{t("onboarding.literalEInfoModal.summary4")}</li>
          </ul>
          <p className="pt-2">
            <a
              href="https://www.gub.uy/direccion-general-impositiva/comunicacion/publicaciones/regimen-iva-minimo-pequena-empresa"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary underline transition-colors hover:no-underline focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 rounded"
            >
              {t("onboarding.literalEInfoModal.officialLinkText")}
            </a>
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
